import { render, staticRenderFns } from "./OCUserData.html?vue&type=template&id=4b8262aa&scoped=true&"
import script from "./OCUserData.ts?vue&type=script&lang=ts&"
export * from "./OCUserData.ts?vue&type=script&lang=ts&"
import style0 from "./OCUserData.css?vue&type=style&index=0&id=4b8262aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8262aa",
  null
  
)

export default component.exports